import clsx from "clsx";
import { Title } from "../Title";
import { jsx as _jsx } from "react/jsx-runtime";
var DocumentTitle = function DocumentTitle(_ref) {
  var type = _ref.type,
    children = _ref.children,
    left = _ref.left;
  return /*#__PURE__*/_jsx(Title, {
    as: "h6",
    className: clsx("mb-1 font-medium", {
      "mt-4": type === "nested",
      "text-center": !left
    }),
    children: children
  });
};
export default DocumentTitle;
//# sourceMappingURL=DocumentTitle.js.map